<template>
    <vue-scroll>
        <div :style="{'height':(clientHeight-98)+'px'}">
            <div class="left" v-loading="loading">
                <div class="card">
                    <div class="card-body">
                        <div v-if="powers.includes(90)">
                            <el-form v-for="headTeacher in headTeachers" :key="headTeacher.id">
                                <el-form-item>
                                    <el-button class="headTeacher" @click="handleShowReferrer(headTeacher.id)">
                                        {{headTeacher.name}}
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-else>
                            <el-form v-for="headTeacher in headTeachers" :key="headTeacher.id">
                                <el-form-item v-if="localEmployee.id==headTeacher.id">
                                    <el-button class="headTeacher" @click="handleShowReferrer(headTeacher.id)">
                                        {{headTeacher.name}}
                                    </el-button>
                                </el-form-item>
                                <el-form-item v-if="localEmployee.id!=headTeacher.id">
                                    <el-button class="headTeacher" @click="handleShowReferrer(headTeacher.id)" disabled>
                                        {{headTeacher.name}}
                                    </el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <HeadTeacherReferrerList v-if="toReferrer===employee&&toReferrer1===true"
                                         :employee="employee" ></HeadTeacherReferrerList>
            </div>
        </div>
    </vue-scroll>
</template>
<script>
    import HeadTeacherReferrerList from './HeadTeacherReferrerList'

    export default {
        name: "List",
        data() {
            return {
                path: '/referrers/list',
                loading: true,
                activeList: true,
                toReferrer: '',
                toReferrer1: false,
                headTeachers: [],
                localEmployee: [],
                employee: '',
                dialog_AddReferrerExchangePresent: {
                    button_loading: false,
                    activities: [],
                    referrer: [],
                    presents: [],
                    can_exchange_number: '',
                },
                headTeacherReferrerList: {
                    headTeacherReferrers: [],
                    students: [],
                    type: '',
                    student_id: '',
                    total: 0,
                    isShow: false,
                    referrer: '',
                    loading: false
                }
            }
        },
        components: {
            HeadTeacherReferrerList
        },
        created() {
            this.handleCreate();
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            }
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
                this.$wApi.send(this.path, 'get_init');
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'get_init':
                        this.headTeachers = data.get_init;
                        this.loading = false;
                        break;
                    case 'store_exchangePresent':
                        this.$message({
                            message: '兑换成功',
                            type: 'success'
                        });
                        this.headTeacherReferrerList.headTeacherReferrers = data.store_exchangePresent.headTeacherReferrers;
                        this.headTeacherReferrerList.students = data.store_exchangePresent.students;
                        this.headTeacherReferrerList.total = data.store_exchangePresent.total;
                        this.headTeacherReferrerList.loading = false;
                        this.dialog_AddReferrerExchangePresent.button_loading = false;
                        this.$Win.closeModal();
                        break;
                    case 'store_exchangePresent_error':
                        this.dialog_AddReferrerExchangePresent.button_loading = false;
                        break;
                    case'get_headTeacherReferrerList':
                        this.headTeacherReferrerList.headTeacherReferrers = data.get_headTeacherReferrerList.headTeacherReferrers;
                        this.headTeacherReferrerList.students = data.get_headTeacherReferrerList.students;
                        this.headTeacherReferrerList.total = data.get_headTeacherReferrerList.total;
                        this.headTeacherReferrerList.loading = false;
                        break;
                    case'get_student':
                        this.headTeacherReferrerList.students = data.students;
                        break;
                    case'get_giftInfo':
                        this.dialog_AddReferrerExchangePresent.referrer = data.get_giftInfo.referrer;
                        this.dialog_AddReferrerExchangePresent.activities = data.get_giftInfo.activities;
                        this.dialog_AddReferrerExchangePresent.presents = data.get_giftInfo.presents;
                        this.dialog_AddReferrerExchangePresent.can_exchange_number = data.get_giftInfo.can_exchange_number;
                        break;
                }
            },
            handleShowReferrer(employee_id) {
                this.employee = employee_id;
                this.$nextTick(() => {
                    this.toReferrer = employee_id;
                    this.toReferrer1 = true;
                })
            },
            handleChangeList() {
                this.activeList = !this.activeList;
            },
            // handleAddTemplate() {
            //     this.$Win.openModal('Dialog_AddReferrerExchangePresent', 1024, 200, '添加兑换礼物');
            // },
        },
    }
</script>

<style scoped>
    .left {
        float: left;
        width: 160px;
    }

    .right {
        margin-left: 172px;
    }

    .headTeacher {
        width: 120px;
    }

    .headTeacher:hover {
        box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.24), 0 5px 5px 0 rgba(0, 0, 0, 0.19);
    }

</style>
